<template>
    <div>
        <vs-prompt @cancel="val=''" blur @accept="acceptAlert" @close="close" :active.sync="activePrompt"
            accept-text="Add" title="Add New language">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Arabic Name" v-model="language.ar_name" />
                <vs-input placeholder="English Name" v-model="language.en_name" />
            </div>
        </vs-prompt>
       
        <vs-table :data="$store.state.languages.all" stripe>
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <div @click="activePrompt = true;language =def_language"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New language</span>
                    </div>
                </div>
            </div>
            <template #thead>
                <vs-th>Arabic name</vs-th>
                <vs-th>English name</vs-th>
                <vs-th>Movies</vs-th>
                <vs-th>Series</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr v-for="(language,index) in data" :key="index">
                        <vs-td class="font">{{language.ar_name}}</vs-td>
                        <vs-td class="font">{{language.en_name}}</vs-td>
                        <vs-td>{{language.movies}}</vs-td>
                        <vs-td>{{language.series}}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(language)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(language)" />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                select1: 2,
                activePrompt: false,
                delConfirm: false,
                val: '',
                def_language: {
                    id: 0,
                    ar_name: '',
                    en_name: ''
                },
                language: {
                    id: 0,
                    ar_name: '',
                    en_name: ''
                }
            }
        },
        created() {
            this.$store.dispatch('languages/fetchLanguages')
        },
        methods: {
            openConfirm(language) {
                this.language=language;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete language`,
                    text: 'Are you sure to delete this item ?',
                    accept:this.del,
                    close:this.close
                })
            },
            acceptAlert(color) {
                const data = new FormData();
                data.append('id', this.language.id);
                data.append('ar_name', this.language.ar_name);
                data.append('en_name', this.language.en_name);
                this.axios.post(`${this.$apiUrl}/languages`, data).then(res => {
                    this.language = this.def_language;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'language Addedd',
                            text: res.data.response.en_name
                        })
                    }
                    this.$store.dispatch('languages/fetchLanguages')
                })

            },
            close() {
                this.language = this.def_language;
            },
            edit(language) {
                this.language = language;
                this.activePrompt = true;
            },
            del() {
                 this.axios.post(`${this.$apiUrl}/languages/delete/${this.language.id}`).then(res => {
                    this.language = this.def_language;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'language Deleted !',
                            text: res.data.response.en_name
                        })
                    }
                    this.$store.dispatch('languages/fetchLanguages')
                })

            },
        }
    }
</script>
<style lang="scss">
    .con-exemple-prompt {
        padding: 10px;
        padding-bottom: 0px;

        .vs-input {
            width: 100%;
            margin-top: 10px;
        }

    }
</style>